<template>
  <div class="index-page-channel">
    <div class="top-banner">
      <img :src="require('@/assets/banner-bg.png')"  alt="">
    </div>
    <van-tabs v-model="active" sticky @scroll="changeScroll" @click="changeTab" line-width="20px" title-active-color="#333" title-inactive-color="#666">
      <van-tab title="COSE证书查询"></van-tab>
      <van-tab title="授权机构查询">
        <div class="org-search">
      <!-- <div :class="['search-box']" :style="wrapStyle">
        <van-field v-model="channel" clearable @clear="clearChannel" placeholder="授权机构"/>
        <van-field v-model="org" clearable @clear="clearOrg" placeholder="课程名称"/>
        <van-button color="#0751A8" type="info" size="small"  @click="getlist" block class="search-btn">查询</van-button>
      </div> -->
      <!-- <div class="table-head">
        <ul class="" style="display:flex;">
          <li style="width: 20%">渠道名称</li>
          <li style="width: 20%">授权类别</li>
          <li style="width: 40%">授权类别</li>
        </ul>
      </div> -->
      <!-- <div class="breadcrumb">
        <span class="breadcrumb-item">
          <span class="link"><a href="/certChannel">合作机构查询</a></span>
          <span class="breadcrumb_separator">/</span>
        </span>
        <span class="breadcrumb-item">
          <span class="link">机构查询</span>
          <span></span>
        </span>
      </div> -->
      <div class="result-table" v-if="tablelist.length > 0">
        <div class="table-header" :style="tableStyle">
          <table class="table-con">
            <thead>
              <th style="width: 25%">授权机构</th>
              <!-- <th style="width: 20%">负责人</th>
              <th style="width: 20%">授权方向</th> -->
              <th style="width: 45%">授权课程</th>
              <th style="width: 30%">授权时间</th>
            </thead>
          </table>
        </div>
        <div class="table-body" v-infinite-scroll="load" :infinite-scroll-distance="50" :infinite-scroll-delay="500" :infinite-scroll-disabled="!loadMore">
          <table class="table-con">
            <tbody  v-for="(item,index) of tablelist" :key="index">
              <tr v-for="(data,index) of item.data" :key="index">
                <td style="width: 25%" :rowspan="item.data.length"  v-if="index == 0">
                  <a :href="`/orgDetail?org_id=${data.org_id}`">{{item.name}}</a>
                </td>
                <!-- <td :rowspan="item.data.length"  v-if="index == 0">{{item.linkman}}</td> -->
                <!-- <td  :class="data.overtime==0 ? '':'bgccc'">
                {{data.direction_name}}
                </td> -->
                <td style="width: 45%" :class="data.overtime==0 ? '':'bgccc'">
                  <a :href="`/orgDetail?org_id=${data.org_id}&id=${data.id}`" style="display:block;overflow: hidden;width: 100%;">
                    <span class="text-overflow ellipsis2" >{{data.direction_name}}</span>
                  </a>
                </td>
                <td style="width: 30%" :class="data.overtime==0 ? '':'bgccc'">
                  {{data.begintime_text}} <br/>至 {{data.endtime_text}}
                </td>
                <!-- <td  :class="data.overtime==0 ? '':'bgccc'">
                {{data.auth_code}}
                </td> -->
              </tr>
            </tbody>
          </table>
          <div class="loading-box" v-if="loadMore">
            <van-loading text-color="#0094ff" color="#0094ff" vertical>加载中...</van-loading>
          </div>
          <div class="loading-box" v-else>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div class="result-empty" v-else>
        <img :src="require('@/assets/empty-data.png')" alt="">
        <p>未找到相关机构</p>
      </div>
    </div>
      </van-tab>
      <van-tab title="项目管理办法"></van-tab>
    </van-tabs>
    
  </div>
</template>
<script>
import Tab from 'vant/lib/tab'
import Tabs from 'vant/lib/tabs'
import Button from 'vant/lib/button'
import Loading from 'vant/lib/loading'
import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'
import 'vant/lib/button/style'
import 'vant/lib/loading/style'
import {index} from "@/api/common.js";
import { InfiniteScroll } from "element-ui"
import { Toast } from 'vant'
function showOverflowHiddenText (el, value) {
  console.log(el)
  console.log(el.offsetWidth)
  console.log(value)
  console.log(el.scrollWidth)
  if (el.offsetHeight > 40) {
  // if (isOver) {
  //   let title = value
  //   if (!value) {
  //     var re1 = new RegExp('<.+?>', 'g')
  //     title = el.innerHTML.replace(re1, '')
  //   }
  //   el.setAttribute('title', title)
  // }
  el.style.overflow="hidden"
  el.style.height="40px"
  el.style.position = 'relative'
  el.setAttribute('class', 'text-overflow more')
  el.setAttribute('title', value)

}
}
export default {
  metaInfo: {
    title: '合作渠道查询'
  },
  data () {
    return {
      active: 1,
      channel: '',
      org: '',
      isFixed: false,
      page: 1,
      loadMore: true,
      tablelist: [],
      loading: true
    }
  },
  directives: {
    "infinite-scroll": InfiniteScroll,
    title: {
      inserted: (el, binding, vnode) => {
        showOverflowHiddenText(el, binding.value ? binding.value : '')
      },
      update: (el, binding, vnode) => {
        showOverflowHiddenText(el, binding.value ? binding.value.title : '')
      }
    }
  },
  computed: {
    wrapStyle() {
      return {
        // 吸顶时给定一个等于导航高度的paddingTop值，用于遮住透明的导航+状态栏区域
        top: this.isFixed ? '44px' : 0,
        position: this.isFixed ? 'fixed': 'static',
        height: '65px'
      }
    },
    contentStyle() {
      return {
        // 吸顶时给定一个等于导航高度的paddingTop值，用于遮住透明的导航+状态栏区域
        marginTop: this.isFixed ? '114px' : '0px',
      }
    },
    tableStyle() {
      return {
        // 吸顶时给定一个等于导航高度的paddingTop值，用于遮住透明的导航+状态栏区域
        top: this.isFixed ? '109px' : 0,
        position: this.isFixed ? 'fixed': 'static',
        // height: this.isFixed ? '65px': 'auto',
        // padding: this.isFixed ? '0.32rem 0 0': '0',
        // left: this.isFixed ? '0.32rem' : '0',
        // width: this.isFixed ? 'calc(100% - 0.64rem)' : '100%',
        // display:this.isFixed ? 'block' : 'table-header-group'
      }
    },
    tableBody () {
      return {
        height: this.isFixed ? 'calc(100vh - 167px)': 'auto',
        overflow: this.isFixed ? 'auto' : 'static'
      }
    },
    styleText () {

    }
  },
  components: {
    'van-tabs':Tabs,
    'van-tab': Tab,
    'van-button': Button,
    'van-loading': Loading
  },
  methods: {
    changeTab (value){
      this.$router.push({ path: value === 0 ? '/': value === 2 ? '/projectM' : '/certChannel' })
    },
    changeScroll (options) {
      const { scrollTop, isFixed } = options
      this.isFixed = isFixed
    },
    load () {
      var that=this
      if (!that.loadMore) {
        return 
      }
      that.loading=true
      index("v2/cooperation",{
        page: that.page,
        name:that.channel,
        direction:that.org
      }).then((res) => {
        if (res.code == 0) {
          const dataList = JSON.parse(that.$Base64.decode(res.data))
          that.page === 1 ? that.tablelist = [] : ''
          // const dataSource = dataList.list.map(item => { return item })
          that.tablelist =that.tablelist.concat(dataList.list)
          console.log(that.tablelist)
          console.log(dataList)
          that.total=dataList.count
          if (that.tablelist.length < dataList.count) {
            that.page++
            that.loadMore = true
          } else {
            that.loadMore = false
          }
          that.loading=false
        }
      })
    },
    getlist(){
      var that=this
      that.loadMore = true
      that.page = 1
      this.load()
      // index("v2/cooperation",{
      //   page:1,
      //   name:that.channel,
      //   direction:that.org
      // }).then((res) => {
      //   if (res.code == 0) {
      //     const dataList =JSON.parse(that.$Base64.decode(res.data))
      //     console.log(dataList)
      //     that.tablelist = dataList.list
      //     that.total=dataList.count
      //     that.loading=false
      //   }
      // })
    },
    clearChannel () {
      this.channel = ''
      this.getlist()
    },
    clearOrg () {
      this.org = ''
      this.getlist()
    }
  },
  created () {
    this.channel= this.$route.query.name
    if (this.channel) {
      this.load()
    } else {
      Toast.fail('查询参数确实，返回查询')
      setTimeout(() => { this.$route.push({ path: '/certChannel' }) }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
.index-page-channel {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .top-banner {
    height: 1.44rem;
    width: 100%;
    // position: fixed;
    img {
      height: 1.44rem;
      width: 100%;
    }
  }
  .breadcrumb {
    font-size: 0.26rem;
    padding: 0.2rem 0.32rem 0;
    &_separator{
      margin: 0 9px;
    font-weight: 700;
    color: #c0c4cc;
    }
    .breadcrumb-item {
      .link {
        color: #999;
      }
      .link a {
        color: #0751A8;
        
      }
    }
  }
  .org-search {
    .search-box {
      box-sizing: border-box;
      width: 100%;
      height: 1.3rem;
      padding:  0.32rem 0.32rem 0.34rem;
      display: flex;
      background: linear-gradient(270deg, #3e88de, #7bb1f1 100%);
      &.fixed {
        position: fixed;
        top: 44px;
        width: 100%;
      }
    }
  }
  .result-table {
    // margin: 0.32rem;
    .table-con {
      width: calc( 100vw - 0.64rem );
      border-width: 0px;
      // border-top: 1px solid #666;
      // border-right: 1px solid #666;
      thead, tbody {
        width: 100%;
        background-color: #fff;
      }
      // thead {
      //   display: block;
      // }
      // thead th {
      //   display: inline-block;
      // }
      thead th, tbody td {
        font-weight: normal;
        color: #444;
        font-size: 0.26rem;
        border-width: 0;
        border-right: 1px solid #666;
        border-bottom: 1px solid #666;
        // border-top: 1px solid #666;
        padding: 0.2rem 0;
        text-align: center;
        &:first-child{
          border-left: 1px solid #666;
        }
      }
      tbody td.bgccc {
        background: #eee;
        .text-overflow {
        // display: inline-block;
        line-height: 20px;
        &.more {
          &::after{
            content: '...';
            position: absolute;
            height: 20px;
            bottom: 0;
            right: 0;
            width: 20px;
            background: rgb(204,204,204);
          }
        }
      }
        
      }
    }
    .table-header {
      padding: 0.2rem 0.32rem 0;
      background: #fff;
      width: 100%;
      table-layout: fixed;
      // height: 1.16rem;
      .table-con {
        border-top: 1px solid #666;
        border-bottom: 1px solid #666;
      }
      
    }
    .table-body {
      padding: 0 0.32rem;
      height:calc(100vh - 174px);
      overflow: auto;
      .loading-box {
        padding-bottom: 20px;
        text-align: center;
        p {
          font-size: 14px;
          text-align: center;
          color:#666;
        }
      }
      .text-overflow {
        // display: inline-block;
        line-height: 20px;
        // width: 200px;
        // height: 40px;
        &.more {
          &::after{
            content: '...';
            position: absolute;
            height: 20px;
            bottom: 0;
            right: 0;
            width: 20px;
            background: #fff;
          }
        }
      }
    }
  }
  .result-empty {
    text-align: center;
    img {
      width: 2.8rem;
      height: auto;
      margin-top: 2.4rem;
    }
    p{
      color:#7f7f7f;
      font-size: 0.28rem;
      margin-top: 0.48rem;
    }
  }
}
</style>
<style>
.van-tabs__line {
  background-color: #0751A8;
}
.org-search .search-box .van-cell {
  padding: 4px 8px;
  border-radius: 0.08rem;
  margin-right: 0.32rem;
  width: calc((100% - 1.76rem) / 2);
}
.org-search .search-box .search-btn {
  width: 1.12rem;
}
</style>